


const backendUrl = process.env.REACT_APP_BACKEND_URL;

const apiFetch = async (url, options = {}) => {
  const response = await fetch(`${backendUrl}${url}`, {
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      ...(options.headers || {})
    },
    ...options
  });

  if (!response.ok) {
    const error = new Error(`Request failed with status ${response.status}`);
    error.status = response.status;
    throw error;
  }

  return response.json();
};
export const cosmeticIQApi = {
  updatedata: async (data) => {
    return apiFetch('/update_data', {
      method: 'POST',
      body: JSON.stringify(data)
    });
  },
  updateTitle: async (data) => {
    return apiFetch('/update_title', {
      method: 'POST',
      body: JSON.stringify(data)
    });
  },
 saveReport: async ({ title, conditions, product_count }) => {
    return apiFetch("/save_report", {
      method: "POST",
      body: JSON.stringify({
        title,
        conditions,
        product_count,
      }),
    });
  },
  handleDelete: async (data) => {
    return apiFetch("/delete", {
      method: "POST",
      body: JSON.stringify(data),
    });
  },
  saveView: async ({ title, filters, product_count }) => {
    return apiFetch("/save_view", {
      method: "POST",
      body: JSON.stringify({
        title,
        filters,
        product_count,
      }),
    });
  },
saveTrend: async (trendId) => {
  return apiFetch(`/save_trend/${trendId}`, {
    method: 'POST',
  });
},
unsaveTrend: async (trendId) => {
  return apiFetch(`/unsave_trend/${trendId}`, {
    method: 'POST',
  });
},
fetchSavedTrends: async () => {
    return apiFetch('/fetch_saved_trends', {
      method: 'GET',
    });
  },
  fetchSavedReports: async () => {
    return apiFetch('/fetch_saved_reports', {
      method: 'GET',
    });
  },
  fetchSavedViews: async () => {
    return apiFetch('/fetch_saved_views', {
      method: 'GET',
    });
  },
  login: async (formData) => {
  return apiFetch('/login', {
    method: 'POST',
    body: JSON.stringify(formData)
  });
},
 updateUserSignIn: (email) =>
  apiFetch('/update_user_sign_in', {
    method: 'POST',
    body: JSON.stringify({ email })
  }),
getUserData: async () => {
  return apiFetch('/get_user');
},
 checkAuth: async () => {
  try {
    await apiFetch('/check-auth');
    return true;
  } catch {
    return false;
  }
},
  getIndustryNews: () => apiFetch('/industry_news'),
  getTrends: () => apiFetch('/trend_list'),
  getTrendById:(id) => apiFetch(`/trend_info?id=${id}`),
  getNewProducts: (days, segmentId) => {
  let url = `/new_products?days=${days}`;

  if (segmentId) {
    url += `&segment=${segmentId}`;
  }

  return apiFetch(url);
},
getSegments: () => apiFetch('/segments'),
getPopularProducts: () => apiFetch('/popular_products'),
getQuickPullReports: () => apiFetch('/quick_pull_reports'),
getStats: () => apiFetch('/stats'),
builderSearch: (searchTable, searchText) =>
  apiFetch(`/builder_search?search_table=${searchTable}&search_text=${encodeURIComponent(searchText)}`),

builderExecute: (report) =>
  apiFetch('/builder_execute', {
    method: 'POST',
    body: JSON.stringify({ report })
  }),
  logout: () =>
  apiFetch('/logout', {
    method: 'POST',
  }),
  

};
